"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayjs = void 0;
const tslib_1 = require("tslib");
const dayjs_1 = tslib_1.__importStar(require("dayjs"));
const advancedFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/advancedFormat"));
const customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
const dayOfYear_1 = tslib_1.__importDefault(require("dayjs/plugin/dayOfYear"));
const duration_1 = tslib_1.__importDefault(require("dayjs/plugin/duration"));
const localeData_1 = tslib_1.__importDefault(require("dayjs/plugin/localeData"));
const localizedFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/localizedFormat"));
const relativeTime_1 = tslib_1.__importDefault(require("dayjs/plugin/relativeTime"));
const timezone_1 = tslib_1.__importDefault(require("dayjs/plugin/timezone"));
const utc_1 = tslib_1.__importDefault(require("dayjs/plugin/utc"));
const shortTimezoneAbbreviation_1 = require("./plugins/shortTimezoneAbbreviation");
// eslint-disable-next-line import/no-unassigned-import
require("./localesList");
// Configure dayjs with all required plugins
(0, dayjs_1.extend)(advancedFormat_1.default);
(0, dayjs_1.extend)(customParseFormat_1.default);
(0, dayjs_1.extend)(dayOfYear_1.default);
(0, dayjs_1.extend)(duration_1.default);
(0, dayjs_1.extend)(localeData_1.default);
(0, dayjs_1.extend)(localizedFormat_1.default);
(0, dayjs_1.extend)(relativeTime_1.default);
(0, dayjs_1.extend)(timezone_1.default);
(0, dayjs_1.extend)(utc_1.default);
(0, dayjs_1.extend)(shortTimezoneAbbreviation_1.shortTimezoneAbbreviation);
const localeMapping = Object.freeze({
    'zh-Hans': 'zh-cn',
    'zh-Hant': 'zh-tw',
});
const getDayjs = ({ language }) => {
    let dayjsLocale = 'en';
    dayjsLocale =
        (localeMapping === null || localeMapping === void 0 ? void 0 : localeMapping[language]) || language;
    (0, dayjs_1.locale)(dayjsLocale);
    return dayjs_1.default;
};
exports.getDayjs = getDayjs;
//# sourceMappingURL=getDayjs.js.map